import React, { useState } from 'react';
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import Layout from '../../components/Layout';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import SubHeader from '../../components/SubHeader';
import Spinner from '../../components/Spinner';
import Link from "next/link";
import styles from '../../styles/Signin.module.css';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
// import Spinner from 'react-bootstrap/Spinner';
import { commonUrl } from '../api/config';
import * as LIB from '../../lib/common';

const SignIn = () => {
    const [headData, setHeadData] = useState([]);
    const [validated, setValidated] = useState(false);
    const [isLoading, setDidLoad] = useState(false);
    const [failTxt, setFailTxt] = useState('');
    const router = useRouter();

    useEffect(() => {
        getHeadData();
    }, []);

    const getHeadData = () => {
        let data = [];
        data['title'] = '帳戶登入';
        data['description'] = '帳戶登入，登入後留下感言。';
        setHeadData(data);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setDidLoad(true);

        //construct data
        let form = event.target;
        let data = {
            username: form.userName.value,
            password: form.password.value,
            remember: form.rememberMe.checked == true ? 1 : 0,
        };

        setValidated(true);

        //check if field is not filled
        for (const key in data) {
            let item = data[key];
            if (!item && key != 'remember' || item == '' && key != 'remember') {
                // console.log('stopped !!');
                setDidLoad(false);
                return;
            }
        }

        let apiUrl = commonUrl.signIn;
        const reqOpt = {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(data)
        };

        fetch(apiUrl, reqOpt)
            .then(response => response.json())
            .then(data => {
                // console.log('return data=', data);
                if (data.result == true) {
                    //login successfully, fetch session
                    fetchSession(data.message);
                } else if (data.result == false) {
                    setFailTxt(data.message);
                }
            });
    }

    const fetchSession = async (apiUrl) => {

        const res = await fetch(apiUrl, {
            credentials: "include"
        });

        //console.log('res=', res); 
        if (res.status == 200 && res.ok === true) {
            window.location.href = LIB.getBasepath('/');
        }
        else {
            window.location.href = LIB.getBasepath('/');
        }
    }

    const renderForm = () => {
        return (
            <div className={styles.authWrapper} onSubmit={handleSubmit}>
                <div className={styles.authInner}>
                    <Form noValidate validated={validated}>
                        <div className={styles.header}>帳戶登入</div>

                        <Form.Group className="mb-3" controlId="userName">
                            <Form.Label className={styles.label}>帳戶名稱</Form.Label>
                            <Form.Control type="text" placeholder=" " required />
                            <Form.Control.Feedback type="invalid">
                                請輸入帳戶名稱
                            </Form.Control.Feedback>
                            <Form.Text className="text-muted"></Form.Text>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="password">
                            <Form.Label className={styles.label}>登入密碼</Form.Label>
                            <Form.Control type="password" placeholder=" " required />
                            <Form.Control.Feedback type="invalid">
                                請輸入登入密碼
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="rememberMe">
                            <Form.Check className={styles.label} type="checkbox" label="記住我" />
                        </Form.Group>

                        <Container fluid>
                            <Row className={styles.row}>
                                <Col className={styles.centerColum}>
                                    {!isLoading && <Button className={styles.loginButton} type="submit">登入</Button>}
                                    {isLoading && <Spinner />}
                                </Col>
                            </Row>
                        </Container>

                    </Form>
                </div>
            </div>
        );
    }

    const renderFailTxt = () => {
        return (
            <div className={styles.authWrapper}>
                <div className={styles.authInner}>
                    <div className={styles.header}>帳戶登入</div>
                    <div className={styles.fail}>{failTxt}</div>
                    <div className={styles.centerColum}>
                        <a href={LIB.getBasepath('/signin')}><div className={styles.reLoginButton} type="submit">重新嘗試</div></a>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Layout>
            <title>錫安日報 | 帳戶登入</title>
            <Header />
            <SubHeader data='帳戶登入' />
            <div className={styles.holder}>
                <div className="wrapper">
                    {failTxt == '' ? renderForm() : renderFailTxt()}
                </div>
            </div>
            <Footer />
        </Layout>
    );
}

export default SignIn;